<div *ngFor="let c of churches; let i = index" [class.ka-separator]="i > 0">
    <app-church-widget [church]="c" [search]="true"></app-church-widget>
</div>